import { render, staticRenderFns } from "./VoteSearch.vue?vue&type=template&id=89364af2&scoped=true"
import script from "./VoteSearch.vue?vue&type=script&lang=js"
export * from "./VoteSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89364af2",
  null
  
)

export default component.exports